import React from 'react'
import './HomeStyle.css'
import home1 from '../../Assets/home1.png'
import home2 from '../../Assets/home2.png'
import home3 from '../../Assets/home3.png'

import { Carousel } from 'react-bootstrap'
import { NavBar } from '../../Components/Navigation/NavBar'
import { News } from '../../Components/News/News'
import { Footer } from '../../Components/Footer/Footer'


export const Home = () => {
  return (
    <div>
       <NavBar />
      <Carousel className="banner" interval={3000}>
        <Carousel.Item className="banner-item">
          <img className="d-block w-100" src={home1} alt="First slide" />
          {/* <Carousel.Caption>
            <h2>''Efforts May Fail But Don't Fail To Make an Effort''</h2>
          </Carousel.Caption> */}
        </Carousel.Item>
        <Carousel.Item className="banner-item">
          <img className="d-block w-100" src={home2} alt="Second slide" />
          {/* <Carousel.Caption>
            <h5>New App Launched</h5>
            <p>Insta Profiler for Android Download Now</p>
          </Carousel.Caption> */}
        </Carousel.Item>
        <Carousel.Item className="banner-item">
          <img className="d-block w-100" src={home3} alt="Third slide" />
          <Carousel.Caption>
            {/* <h5>Stay Tuned for Awesome Updates!</h5> */}
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      <section>
        <div>
          <h2 className="text-center">Our Vision</h2>
          <p className="mt-3 text-center" style={{ width: '100%' }}>
            SaneDroid's vision is to develop software products that could help
            world to be united by keeping true core value of "SANITY!".
          </p>
        </div>
      </section>

      <News />
      <Footer/>
    </div>
  )
}
